import { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';

import LoginDisplay from './LoginDisplay';
import './NavMenu.css';

const SCROLL_THRESHOLD = 20;

export default function NavMenu() {
  const [collapseNavMenu, setCollapseNavMenu] = useState(true);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > SCROLL_THRESHOLD);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const toggleNavMenu = () => setCollapseNavMenu((collapsed) => !collapsed);
  const closeNavMenu = () => setCollapseNavMenu(true);

  return (
    <header className={`shack-nav${scrolled ? ' scrolled' : ''}`}>
      <div className="nav-inner">
        <Link className="nav-brand" to="/" onClick={closeNavMenu}>
          <img
            src="/images/Chuck's Mojito Shack.png"
            alt="Chuck's Mojito Shack"
            className="nav-logo"
          />
          <span className="nav-brand-text">
            Chuck's
            <br />
            <span className="nav-brand-sub">Mojito Shack</span>
          </span>
        </Link>

        <button
          type="button"
          className="nav-toggle"
          title="Navigation menu"
          aria-label="Navigation menu"
          aria-expanded={!collapseNavMenu}
          onClick={toggleNavMenu}
        >
          <span className="toggle-bar"></span>
          <span className="toggle-bar"></span>
          <span className="toggle-bar"></span>
        </button>

        <nav
          className={`nav-links ${collapseNavMenu ? 'collapsed' : 'open'}`}
          onClick={closeNavMenu}
        >
          <NavLink className="nav-link" to="/" end>
            Home
          </NavLink>
          <Link className="nav-link" to="/#menu">
            Menu
          </Link>
          <Link className="nav-link" to="/#about">
            About
          </Link>
          <Link className="nav-link" to="/#gallery">
            Gallery
          </Link>
          <NavLink className="nav-link" to="/team">
            Team
          </NavLink>
          <NavLink className="nav-link" to="/kourt">
            Kourt
          </NavLink>
          <NavLink className="nav-link nav-link-mix" to="/mix">
            Mix Your Own
          </NavLink>
          <div className="nav-auth">
            <LoginDisplay />
          </div>
        </nav>
      </div>
    </header>
  );
}
